<template>
  <div class="payment-methods">
    <div v-for="method in list" :key="method.type">
      <tooltip
        v-if="method.type === 'invoice_request'"
        placement="top"
        min-width="200"
        max-width="200"
        theme="light"
        :content="$t('payment.legal_entities')"
      >
        <radio-img-button
          :id="method.type"
          :value="method.type"
          :disabled="method.disabled"
          :model_value="value"
          @input="input"
        >
          <template v-slot:img="{ is_checked, is_disabled }">
            {{ method.minimal }}

            <img
              :src="`${method.img_src}`"
              class="payment-methods__elem"
              :class="img_classes(is_checked, is_disabled)"
            />
          </template>
        </radio-img-button>
      </tooltip>
      <radio-img-button
        v-else
        :id="method.type"
        :value="method.type"
        :disabled="method.disabled"
        :model_value="value"
        @input="input"
      >
        <template v-slot:img="{ is_checked, is_disabled }">
          {{ method.minimal }}

          <img
            :src="`${method.img_src}`"
            class="payment-methods__elem"
            :class="img_classes(is_checked, is_disabled)"
          />
        </template>
      </radio-img-button>
    </div>
  </div>
</template>

<script>
  import RadioImgButton from '@payment/components/radio-img-button.vue';

  export default {
    components: {
      RadioImgButton
    },
    props: {
      value: {
        type: String,
        required: true
      },
      list: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      },
      img_classes(is_checked = false, is_disabled = false) {
        return {
          'payment-methods__elem--active': is_checked,
          'payment-methods__elem--disabled': is_disabled
        };
      }
    }
  };
</script>
<style lang="scss">
  .payment-methods {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    &__elem {
      box-sizing: border-box;
      width: 140px;
      height: 60px;
      border-radius: 10px;
      padding-left: 15px;
      padding-right: 15px;
      object-fit: contain;
      border-radius: 4px;
      background: #fff;
      border: 2px solid transparent;

      &:hover {
        cursor: pointer;
        border-color: $primary;
        background: #2196f32b;
      }

      &--active {
        border-color: $primary;
        background: #2196f32b;
      }

      &--disabled {
        opacity: 0.7;
        &:hover {
          cursor: not-allowed;
        }
      }
    }

    &__check {
      position: absolute;
      top: -5px;
      right: -5px;
      width: 15px;
    }
  }
</style>
